import React, { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { get, post } from "../../services/api";
import Select from "react-select";
import { toast } from "react-toastify";
import StudentStrengthReportPdfGenerator from "../../components/PdfGenerator/StudentStrengthReportPdfGenerator";

function StudentStrengthReport() {
  const token = localStorage.getItem("token");
  const organizationId = localStorage.getItem("organizationId");
  const savedCenterId =
    localStorage.getItem("centerId") === "null"
      ? 0
      : localStorage.getItem("centerId");

  const {
    register,
    formState: { errors, isSubmitting },
    control,
    handleSubmit,
    watch,
    setValue,
    getValues,
    trigger,
    reset,
    setError,
  } = useForm();

  const [loading, setLoading] = useState(false);
  const [centerId, setCenterId] = useState(savedCenterId || 0);
  const [selectedClassId, setSelectedClassId] = useState(0);

  const [centersData, setCentersData] = useState([]);
  const [classesData, setClassesData] = useState([]);

  const [reportData, setReportData] = useState(null);

  useEffect(() => {
    const fetchCenters = async () => {
      try {
        const response = await get(
          `Dropdown/GetAllCentersByOrganizationId?organizationId=${organizationId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setCentersData(response);

        if (savedCenterId) {
          const selectedCenter = response.find(
            (center) => center.id === parseInt(savedCenterId, 10)
          );

          if (selectedCenter) {
            setValue("centerId", {
              value: selectedCenter.id,
              label: selectedCenter.name,
            });

            fetchClassesByCenterId(savedCenterId);
          }
        }
      } catch (error) {
        console.error("Error fetching centers:", error);
      }
    };

    fetchCenters();
  }, []);

  const fetchClassesByCenterId = async (centerId) => {
    try {
      if (centerId) {
        const response = await get(
          `CenterClass/GetClassCenterByCenterId?id=${centerId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setClassesData(response);
      } else {
        setClassesData([]);
      }
    } catch (error) {
      console.error("Error fetching classes:", error);
    }
  };

  const saveData = async () => {
    if (!token) {
      console.error("Unauthorized.");
      return;
    }

    try {
      const response = await get(
        `Student/GetStudentStrengthByOrganizationCenterAndClassesIdAsync?organizationId=${organizationId}&centerId=${centerId}&centerClassId=${selectedClassId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.length) {
        setReportData(response);
      } else {
        toast.error("No data found for this report");
        setReportData(null);
      }
    } catch (error) {
      console.error("Error.", error);
    }
  };

  return (
    <>
      <div className="page-header d-flex mb-2">
        <h2 className="page-heading fs-7">Student Strength Report</h2>
      </div>

      <div className="card">
        <div className="card-body">
          <form onSubmit={handleSubmit(saveData)}>
            <div className="row g-3">
              <div className="col-md-2">
                <label className="form-label">Center</label>
                <Controller
                  name="centerId"
                  control={control}
                  // rules={{ required: "This field is required." }}
                  render={({ field }) => (
                    <Select
                      {...field}
                      options={centersData.map((center) => ({
                        value: center.id,
                        label: center.name,
                      }))}
                      isDisabled={savedCenterId !== "0"}
                      onChange={(selectedOption, actionMeta) => {
                        if (actionMeta.action === "clear") {
                          setValue("centerId", null);
                          setCenterId(0);
                        } else {
                          setValue("centerId", selectedOption);
                          setCenterId(selectedOption.value);
                          fetchClassesByCenterId(selectedOption.value);
                        }
                        setClassesData([]);
                        setValue("centerClassId", null);
                        setSelectedClassId(0);
                        trigger("centerId");
                      }}
                      className="react-select-style"
                      classNamePrefix="react-select-style-pref"
                      isClearable
                    />
                  )}
                />
                {errors.centerId && (
                  <small className="text-danger">
                    {errors.centerId.message}
                  </small>
                )}
              </div>
              <div className="col-md-2">
                <label className="form-label">Class</label>
                <Controller
                  name="centerClassId"
                  control={control}
                  // rules={{ required: "This field is required." }}
                  render={({ field }) => (
                    <Select
                      {...field}
                      options={classesData.map((classSection) => ({
                        value: classSection.id,
                        label: classSection.name,
                      }))}
                      onChange={(selectedOption, actionMeta) => {
                        if (actionMeta.action === "clear") {
                          setValue("centerClassId", null);
                          setSelectedClassId(0);
                        } else {
                          setValue("centerClassId", selectedOption);
                          setSelectedClassId(selectedOption.value);
                        }
                        trigger("centerClassId");
                      }}
                      className="react-select-style"
                      classNamePrefix="react-select-style-pref"
                      isClearable
                    />
                  )}
                />
                {errors.centerClassId && (
                  <small className="text-danger">
                    {errors.centerClassId.message}
                  </small>
                )}
              </div>
              <div className="col">
                <label className="form-label" style={{ visibility: "hidden" }}>
                  Action
                </label>
                <button
                  className="btn btn-primary px-3"
                  type="submit"
                  disabled={isSubmitting}
                  style={{ paddingBlock: "5px" }}
                >
                  {isSubmitting ? "Generating" : "Generate"}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>

      {reportData && (
        <div className="card mt-3">
          <div className="card-body">
            {/* <h5 className="text-center mb-3">Report Preview</h5> */}
            <StudentStrengthReportPdfGenerator reportData={reportData} />
          </div>
        </div>
      )}
    </>
  );
}

export default StudentStrengthReport;
